export const dataDummy = {
    adminDelivery: {
        data: [
            {
                "id": 1,
                "title": "ワークスペースタイトル",
                "memo": "メモメモメモメモ",
                "destinations_companies": [
                    {
                        "id": 1,
                        "company": {
                            "id": 1,
                            "name": "企業",
                            "code": "datastudium",
                            "users_count": 1
                        }
                    }
                ],
                "destinations_groups": [
                    {
                        "id": 1,
                        "group": {
                            "id": 1,
                            "name": "グループ",
                            "users_count": 1
                        }
                    }
                ],
                "destinations_users": [
                    {
                        "id": 1,
                        "user": {
                            "id": 1,
                            "name": 1,
                            "email": "test-account+1@i3design.co.jp",
                            "groups": [
                                {
                                    "id": 1,
                                    "name": "グループ",
                                    "users_count": 1
                                }
                            ],
                            "remark": "HOGEHOGE",
                            "role": {
                                "id": 1,
                                "name": "HOGEHOGE"
                            }
                        }
                    }
                ],
                "topics_count": 1,
                "created_at": "2019/05/18 06:00:00",
                "updated_at": "2019/05/18 06:00:00",
                "deliveried_at": "2019/05/18 06:00:00",
                "created_by": {
                    "id": 1,
                    "name": 1,
                    "email": "test-account+1@i3design.co.jp",
                    "groups": [
                        {
                            "id": 1,
                            "name": "グループ",
                            "users_count": 1
                        }
                    ],
                    "remark": "HOGEHOGE",
                    "role": {
                        "id": 1,
                        "name": "HOGEHOGE"
                    }
                },
                "updated_by": {
                    "id": 1,
                    "name": 1,
                    "email": "test-account+1@i3design.co.jp",
                    "groups": [
                        {
                            "id": 1,
                            "name": "グループ",
                            "users_count": 1
                        }
                    ],
                    "remark": "HOGEHOGE",
                    "role": {
                        "id": 1,
                        "name": "HOGEHOGE"
                    }
                }
            }
        ],
        links: {
            "first": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=1",
            "last": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=23",
            "prev": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=9",
            "next": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=11"
        },
        meta: {
            "current_page": 1,
            "from": 1,
            "to": 10,
            "total": 24,
            "last_page": 23,
            "per_page": 10,
            "path": "http://localhost/api/users"
        }
    },

    delivery: {
        "data": [
            {
                "id": 1,
                "title": "ワークスペースタイトル",
                "memo": "メモメモメモメモ",
                "topics_count": 1,
                "deliveried_at": "2019/05/18 06:00:00",
                "created_at": "2019/05/18 06:00:00",
                "updated_at": "2019/05/18 06:00:00",
                "is_unread": 0
            }
        ],
        "links": {
            "first": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=1",
            "last": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=23",
            "prev": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=9",
            "next": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=11"
        },
        "meta": {
            "current_page": 10,
            "from": 451,
            "to": 500,
            "total": 1133,
            "last_page": 23,
            "per_page": 50,
            "path": "http://localhost/api/users"
        }
    },

    deliveryWorkspace : {
        "data": [
            {
              "id": 1,
              "title": "Topicsタイトル",
              "category_name": "game",
              "game": {
                "id": 1,
                "cup_id": 1,
                "home_team": {
                  "id": 1,
                  "team_name": "巨人",
                  "league_id": 1,
                  "division_id": 1
                },
                "away_team": {
                  "id": 1,
                  "team_name": "巨人",
                  "league_id": 1,
                  "division_id": 1
                },
                "game_date": "2020/03/23",
                "scheduled_game_start_ymd": "20200425",
                "scheduled_game_start_hms": "180000",
                "stadium_name": "東京ドーム",
                "round": 1,
                "series": 1,
                "pitchers": {
                  "home": {
                    "id": 1,
                    "team": {
                      "id": 1,
                      "team_name": "巨人",
                      "league_id": 1,
                      "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                  },
                  "away": {
                    "id": 1,
                    "team": {
                      "id": 1,
                      "team_name": "巨人",
                      "league_id": 1,
                      "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                  }
                }
              },
              "team": {
                "id": 1,
                "team_name": "巨人",
                "league_id": 1,
                "division_id": 1
              },
              "player": {
                "id": 1,
                "team": {
                  "id": 1,
                  "team_name": "巨人",
                  "league_id": 1,
                  "division_id": 1
                },
                "uniform_number": "35",
                "position_type": "セカンド",
                "register_name": "菅野　智之",
                "player_name": "菅野　智之"
              },
              "created_at": "2019/05/18 06:00:00",
              "updated_at": "2019/05/18 06:00:00"
            }
          ]
    },

    playlogSearch: {
        "data": [
            {
                "id": 1,
                "game": {
                    "id": 1,
                    "cup_id": 1,
                    "home_team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "away_team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "game_date": "2020/03/23",
                    "scheduled_game_start_ymd": "20200425",
                    "scheduled_game_start_hms": "180000",
                    "stadium_name": "東京ドーム",
                    "round": 1,
                    "series": 1,
                    "pitchers": {
                        "home": {
                            "id": 1,
                            "team": {
                                "id": 1,
                                "team_name": "巨人",
                                "league_id": 1,
                                "division_id": 1
                            },
                            "uniform_number": "35",
                            "position_type": "セカンド",
                            "register_name": "菅野　智之",
                            "player_name": "菅野　智之"
                        },
                        "away": {
                            "id": 1,
                            "team": {
                                "id": 1,
                                "team_name": "巨人",
                                "league_id": 1,
                                "division_id": 1
                            },
                            "uniform_number": "35",
                            "position_type": "セカンド",
                            "register_name": "菅野　智之",
                            "player_name": "菅野　智之"
                        }
                    }
                },
                "inning": 1,
                "top_bottom": "裏",
                "pa_of_inning": 1,
                "pitcher": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                },
                "batter": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                },
                "play_result": "三振"
            }
        ]
    },

    teamPitchers: {
        "data": [
            {
                "id": 1,
                "player_id": 1,
                "year_id": 1,
                "season_id": 1,
                "team_id": 1,
                "player_name": 1,
                "uniform_number": 1,
                "g": 1,
                "gs": 1,
                "perfect_game": 1,
                "cg": 1,
                "gf": 1,
                "tosho": 1,
                "hokai": 1,
                "sho": 1,
                "mushikyu": 1,
                "qs": 1,
                "w": 1,
                "l": 1,
                "sv": 1,
                "sp": 1,
                "hld": 1,
                "hp": 1,
                "ip_out": 1,
                "ip": 1,
                "ip_frac": 1,
                "bf": 1,
                "ab": 1,
                "h": 1,
                "hr": 1,
                "sh": 1,
                "sf": 1,
                "bb": 1,
                "hbp": 1,
                "ibb": 1,
                "so": 1,
                "wp": 1,
                "bk": 1,
                "r": 1,
                "er": 1,
                "np": 1,
                "era": 0.1,
                "avg": 0.1,
                "wpct": 0.1,
                "k9": 0.1,
                "qs_pct": 0.1,
                "whip": 0.1,
                "k_bb": 1,
                "bb_9": 1,
                "comback_date": "08/14"
            }
        ]
    },

    teamBatters: {
        "data": [
            {
                "id": 1,
                "player_id": 1,
                "year_id": 1,
                "season_id": 1,
                "team_id": 1,
                "player_name": 1,
                "uniform_number": 1,
                "g": 1,
                "pa": 1,
                "ab": 1,
                "r": 1,
                "h": 1,
                "h2b": 1,
                "h3b": 1,
                "hr": 1,
                "tb": 1,
                "rbi": 1,
                "game_winning_rbi": 1,
                "so": 1,
                "bb": 1,
                "hbp": 1,
                "ibb": 1,
                "sh": 1,
                "sf": 1,
                "sb": 1,
                "cs": 1,
                "defensive_interference": 1,
                "gidp": 1,
                "ab_risp": 1,
                "h_risp": 1,
                "avg": 1,
                "slg": 1,
                "obp": 1,
                "avg_risp": 1,
                "sb_pct": 1,
                "ops": 1,
                "e": 1
            }
        ]
    },

    teamSchedule: {
        "data": [
            {
                "id": 1,
                "cup_id": 1,
                "home_team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "away_team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "game_date": 1,
                "scheduled_game_start_ymd": "2020/04/25",
                "scheduled_game_start_hms": "18:00:00",
                "stadium_name": "東京ドーム",
                "round": 1,
                "series": 1,
                "game_name": "xxx",
                "game_status": "xxx",
                "result": {
                    "attendance": 1,
                    "home_team_score": 1,
                    "away_team_score": 1,
                    "w_pitcher": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    },
                    "sv_pitcher": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    },
                    "l_pitcher": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    }
                }
            }
        ]
    },

    teamStartMember: {
        "rank": 1,
        "g": 1,
        "w": 1,
        "l": 1,
        "t": 1,
        "wpct": "0.5",
        "field_manager": {
            "id": 1,
            "team": {
                "id": 1,
                "team_name": "巨人",
                "league_id": 1,
                "division_id": 1
            },
            "uniform_number": "35",
            "position_type": "セカンド",
            "register_name": "菅野　智之",
            "player_name": "菅野　智之"
        }
    },

    playerReportPitcher: {
        "common": {
            "deregistrations": [
                {
                    "id": 1,
                    "transfer_date": "2020/03/20",
                    "transfer_id": 1,
                    "transfer_reason": "xxx",
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "player": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    }
                }
            ],
            "record_to_be_lasts": [
                {
                    "id": 1,
                    "record_name": "2000安打",
                    "remaining_achievement_cnt": 12
                }
            ]
        },
        "ball_type_performances": [
            {
                "pitchtype_name": "シュート",
                "pitch_rate": 1,
                "batting_average": 0.21,
                "missed_swing_rate": 1
            }
        ],
        "ordinary_hits_summuries": [
            {
                "batted_ball_name": "ゴロ",
                "cnt": 1,
                "ratio": 0.1
            }
        ]
    },

    playerPerformance: {

        "pitcher": [
            {
                "id": 1,
                "year_id": 1,
                "year": 2020,
                "season_id": 1,
                "team_id": 1,
                "team_name": 1,
                "player_id": 1,
                "player_name": 1,
                "uniform_number": 1,
                "g": 1,
                "gs": 1,
                "perfect_game": 1,
                "cg": 1,
                "gf": 1,
                "tosho": 1,
                "hokai": 1,
                "sho": 1,
                "mushikyu": 1,
                "qs": 1,
                "w": 1,
                "l": 1,
                "sv": 1,
                "sp": 1,
                "hld": 1,
                "hp": 1,
                "ip_out": 1,
                "ip": 1,
                "ip_frac": 1,
                "bf": 1,
                "ab": 1,
                "h": 1,
                "hr": 1,
                "sh": 1,
                "sf": 1,
                "bb": 1,
                "hbp": 1,
                "ibb": 1,
                "so": 1,
                "wp": 1,
                "bk": 1,
                "r": 1,
                "er": 1,
                "np": 1,
                "era": 0.1,
                "avg": 0.1,
                "wpct": 0.1,
                "k9": 0.1,
                "qs_pct": 0.1,
                "whip": 0.1,
                "k_bb": 1
            }
        ],
        "batter": [
            {
                "id": 1,
                "year_id": 1,
                "year": 2020,
                "season_id": 1,
                "team_id": 1,
                "team_name": 1,
                "player_id": 1,
                "player_name": 1,
                "uniform_number": 1,
                "g": 1,
                "pa": 1,
                "ab": 1,
                "r": 1,
                "h": 1,
                "h2b": 1,
                "h3b": 1,
                "hr": 1,
                "tb": 1,
                "rbi": 1,
                "game_winning_rbi": 1,
                "so": 1,
                "bb": 1,
                "hbp": 1,
                "ibb": 1,
                "sh": 1,
                "sf": 1,
                "sb": 1,
                "cs": 1,
                "defensive_interference": 1,
                "gidp": 1,
                "ab_risp": 1,
                "h_risp": 1,
                "avg": 1,
                "slg": 1,
                "obp": 1,
                "avg_risp": 1,
                "sb_pct": 1,
                "ops": 1
            }
        ]
    },

    teamPublic: {
        "data": [
            {
                "id": 1,
                "transfer_date": "string",
                "transfer_id": 1,
                "transfer_reason": "string",
                "team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "player": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                },
                "after_transfer_team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "trade_target_player_team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "trade_target_player": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                }
            }
        ],
        "links": {
            "first": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=1",
            "last": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=23",
            "prev": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=9",
            "next": "http://localhost/api/users?order=new&max_age=48&min_age=20&page=11"
        },
        "meta": {
            "current_page": 10,
            "from": 451,
            "to": 500,
            "total": 1133,
            "last_page": 23,
            "per_page": 50,
            "path": "http://localhost/api/users"
        }
    },

    news: {
        data: [
            {
                id: 1,
                content: 'content of news asdf asdf askdfa sdfasd fasdf as df',
                opened_at: '2019/05/18 06:00:00',
                is_unread: 0
            }
        ],
        link: {

        },
        meta: {

        }
    },


}

export const dataGame = {
    "summary": {
        "g": 1,
        "w": 0,
        "l": 1,
        "t": 1,
        "r": 1,
        "r2": 1,
        "h": 1,
        "hr": 1,
        "so": 1,
        "bb": 1,
        "hbp": 1,
        "gidp": 1,
        "sb": 1,
        "e": 1,
        "avg": 1,
        "era": 0.1
    },
    "scorelines": [
        {
            "month": 1,
            "games": [
                {
                    "game_date": 1,
                    "w_l_type_name": "〇",
                    "home_team_score": 1,
                    "away_team_score": 1,
                    "starting_pitcher": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    },
                    "responsible_pitchers": [
                        {
                            "player": {
                                "id": 1,
                                "team": {
                                    "id": 1,
                                    "team_name": "巨人",
                                    "league_id": 1,
                                    "division_id": 1
                                },
                                "uniform_number": "35",
                                "position_type": "セカンド",
                                "register_name": "菅野　智之",
                                "player_name": "菅野　智之"
                            },
                            "w_l_sv_type_name": "勝"
                        }
                    ],
                    "stadium_name": "東京ドーム",
                    "game_started_hm": "18:00"
                }
            ]
        },

        {
            "month": 2,
            "games": [
                {
                    "game_date": 1,
                    "w_l_type_name": "〇",
                    "home_team_score": 1,
                    "away_team_score": 1,
                    "starting_pitcher": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    },
                    "responsible_pitchers": [
                        {
                            "player": {
                                "id": 1,
                                "team": {
                                    "id": 1,
                                    "team_name": "巨人",
                                    "league_id": 1,
                                    "division_id": 1
                                },
                                "uniform_number": "35",
                                "position_type": "セカンド",
                                "register_name": "菅野　智之",
                                "player_name": "菅野　智之"
                            },
                            "w_l_sv_type_name": "勝"
                        }
                    ],
                    "stadium_name": "東京ドーム",
                    "game_started_hm": "18:00"
                }
            ]
        }
    ]
}

export const gameResultGeneral =
{
    "detail": {
        "attendance": 10000,
        "game_time": "3:12"
    },
    "umpires": [
        {
            "id": 1,
            "umpire_type_name": "球審",
            "umpire": {
                "id": 1,
                "register_name": "登録名",
                "umpire_name": "審判名"
            }
        }
    ],
    "startings": {
        "home": {
            "pitchers": [
                {
                    "player": {
                        "id": 1,
                        "batting_order": 1,
                        "position_name": "セカンド",
                        "position_name_s": "二",
                        "player": {
                            "id": 1,
                            "team": {
                                "id": 1,
                                "team_name": "DeNA",
                                "league_id": 1,
                                "division_id": 1
                            },
                            "uniform_number": "35",
                            "position_type": "セカンド",
                            "register_name": "菅野　智之",
                            "player_name": "菅野　智之"
                        }
                    },
                    "register_throwt_lr": "左投"
                }
            ],
            "batters": [
                {
                    "player": {
                        "id": 1,
                        "batting_order": 1,
                        "position_name": "セカンド",
                        "position_name_s": "二",
                        "player": {
                            "id": 1,
                            "team": {
                                "id": 1,
                                "team_name": "巨人",
                                "league_id": 1,
                                "division_id": 1
                            },
                            "uniform_number": "35",
                            "position_type": "セカンド",
                            "register_name": "菅野　智之",
                            "player_name": "菅野　智之"
                        }
                    },
                    "register_bat_lr": "左打"
                }
            ]
        },
        "away": {
            "pitchers": [
                {
                    "player": {
                        "id": 1,
                        "batting_order": 1,
                        "position_name": "セカンド",
                        "position_name_s": "二",
                        "player": {
                            "id": 1,
                            "team": {
                                "id": 1,
                                "team_name": "巨人",
                                "league_id": 1,
                                "division_id": 1
                            },
                            "uniform_number": "35",
                            "position_type": "セカンド",
                            "register_name": "菅野　智之",
                            "player_name": "菅野　智之"
                        }
                    },
                    "register_throwt_lr": "左投"
                }
            ],
            "batters": [
                {
                    "player": {
                        "id": 1,
                        "batting_order": 1,
                        "position_name": "セカンド",
                        "position_name_s": "二",
                        "player": {
                            "id": 1,
                            "team": {
                                "id": 1,
                                "team_name": "巨人",
                                "league_id": 1,
                                "division_id": 1
                            },
                            "uniform_number": "35",
                            "position_type": "セカンド",
                            "register_name": "菅野　智之",
                            "player_name": "菅野　智之"
                        }
                    },
                    "register_bat_lr": "左打"
                }
            ]
        }
    }
}

export const gameResultOuting = {
    "home": {
        "batters": [
            {
                "order": {
                    "id": 1,
                    "batting_order": 1,
                    "position_name": "セカンド",
                    "position_name_s": "二",
                    "player": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    }
                },
                "result": {
                    "id": 1,
                    "game_id": 1,
                    "game_date": "2020/04/05",
                    "opponent_team_id": 1,
                    "year_id": 1,
                    "season_id": 1,
                    "team_id": 1,
                    "team_name": 1,
                    "player_id": 1,
                    "player_name": 1,
                    "uniform_number": 1,
                    "g": 1,
                    "pa": 1,
                    "ab": 1,
                    "r": 1,
                    "h": 1,
                    "h2b": 1,
                    "h3b": 1,
                    "hr": 1,
                    "tb": 1,
                    "rbi": 1,
                    "game_winning_rbi": 1,
                    "so": 1,
                    "bb": 1,
                    "hbp": 1,
                    "ibb": 1,
                    "sh": 1,
                    "sf": 1,
                    "sb": 1,
                    "cs": 1,
                    "defensive_interference": 1,
                    "gidp": 1,
                    "ab_risp": 1,
                    "h_risp": 1,
                    "avg": 1,
                    "slg": 1,
                    "obp": 1,
                    "avg_risp": 1,
                    "sb_pct": 1,
                    "ops": 1
                },
                "innings": [
                    0,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            }
        ],
        "pitchers": [
            {
                "players": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                },
                "result": {
                    "id": 1,
                    "game_id": 1,
                    "game_date": "2020/04/05",
                    "opponent_team_id": 1,
                    "year_id": 1,
                    "season_id": 1,
                    "team_id": 1,
                    "team_name": 1,
                    "player_id": 1,
                    "player_name": 1,
                    "uniform_number": 1,
                    "g": 1,
                    "gs": 1,
                    "perfect_game": 1,
                    "cg": 1,
                    "gf": 1,
                    "tosho": 1,
                    "hokai": 1,
                    "sho": 1,
                    "mushikyu": 1,
                    "qs": 1,
                    "w": 1,
                    "l": 1,
                    "sv": 1,
                    "sp": 1,
                    "hld": 1,
                    "hp": 1,
                    "ip_out": 1,
                    "ip": 1,
                    "ip_frac": 1,
                    "bf": 1,
                    "ab": 1,
                    "h": 1,
                    "hr": 1,
                    "sh": 1,
                    "sf": 1,
                    "bb": 1,
                    "hbp": 1,
                    "ibb": 1,
                    "so": 1,
                    "wp": 1,
                    "bk": 1,
                    "r": 1,
                    "er": 1,
                    "np": 1,
                    "era": 0.1,
                    "avg": 0.1,
                    "wpct": 0.1,
                    "k9": 0.1,
                    "qs_pct": 0.1,
                    "whip": 0.1,
                    "k_bb": 1
                }
            }
        ]
    },
    "away": {
        "batters": [
            {
                "order": {
                    "id": 1,
                    "batting_order": 1,
                    "position_name": "セカンド",
                    "position_name_s": "二",
                    "player": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    }
                },
                "result": {
                    "id": 1,
                    "game_id": 1,
                    "game_date": "2020/04/05",
                    "opponent_team_id": 1,
                    "year_id": 1,
                    "season_id": 1,
                    "team_id": 1,
                    "team_name": 1,
                    "player_id": 1,
                    "player_name": 1,
                    "uniform_number": 1,
                    "g": 1,
                    "pa": 1,
                    "ab": 1,
                    "r": 1,
                    "h": 1,
                    "h2b": 1,
                    "h3b": 1,
                    "hr": 1,
                    "tb": 1,
                    "rbi": 1,
                    "game_winning_rbi": 1,
                    "so": 1,
                    "bb": 1,
                    "hbp": 1,
                    "ibb": 1,
                    "sh": 1,
                    "sf": 1,
                    "sb": 1,
                    "cs": 1,
                    "defensive_interference": 1,
                    "gidp": 1,
                    "ab_risp": 1,
                    "h_risp": 1,
                    "avg": 1,
                    "slg": 1,
                    "obp": 1,
                    "avg_risp": 1,
                    "sb_pct": 1,
                    "ops": 1
                },
                "innings": [
                    0,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            }
        ],
        "pitchers": [
            {
                "players": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                },
                "result": {
                    "id": 1,
                    "game_id": 1,
                    "game_date": "2020/04/05",
                    "opponent_team_id": 1,
                    "year_id": 1,
                    "season_id": 1,
                    "team_id": 1,
                    "team_name": 1,
                    "player_id": 1,
                    "player_name": 1,
                    "uniform_number": 1,
                    "g": 1,
                    "gs": 1,
                    "perfect_game": 1,
                    "cg": 1,
                    "gf": 1,
                    "tosho": 1,
                    "hokai": 1,
                    "sho": 1,
                    "mushikyu": 1,
                    "qs": 1,
                    "w": 1,
                    "l": 1,
                    "sv": 1,
                    "sp": 1,
                    "hld": 1,
                    "hp": 1,
                    "ip_out": 1,
                    "ip": 1,
                    "ip_frac": 1,
                    "bf": 1,
                    "ab": 1,
                    "h": 1,
                    "hr": 1,
                    "sh": 1,
                    "sf": 1,
                    "bb": 1,
                    "hbp": 1,
                    "ibb": 1,
                    "so": 1,
                    "wp": 1,
                    "bk": 1,
                    "r": 1,
                    "er": 1,
                    "np": 1,
                    "era": 0.1,
                    "avg": 0.1,
                    "wpct": 0.1,
                    "k9": 0.1,
                    "qs_pct": 0.1,
                    "whip": 0.1,
                    "k_bb": 1
                }
            }
        ]
    }
}

export const gameAnalytics = {
    "home": {
        "pitcher": {
            "id": 1,
            "team": {
                "id": 1,
                "team_name": "巨人",
                "league_id": 1,
                "division_id": 1
            },
            "uniform_number": "35",
            "position_type": "セカンド",
            "register_name": "菅野　智之",
            "player_name": "菅野　智之"
        },
        "opponent_batters": [
            {
                "team_id": 1,
                "team_name": "チーム名",
                "player_id": 1,
                "player_name": "選手名",
                "uniform_number": 1,
                "avg": "0.100",
                "ab": 1,
                "h": 1,
                "hr": 1,
                "so": 1,
                "bb": 1,
                "hbp": 1
            }
        ]
    },
    "away": {
        "pitcher": {
            "id": 1,
            "team": {
                "id": 1,
                "team_name": "巨人",
                "league_id": 1,
                "division_id": 1
            },
            "uniform_number": "35",
            "position_type": "セカンド",
            "register_name": "菅野　智之",
            "player_name": "菅野　智之"
        },
        "opponent_batters": [
            {
                "team_id": 1,
                "team_name": "チーム名",
                "player_id": 1,
                "player_name": "選手名",
                "uniform_number": 1,
                "avg": 0.1,
                "ab": 1,
                "h": 1,
                "hr": 1,
                "so": 1,
                "bb": 1,
                "hbp": 1
            }
        ]
    }
}

export const team1 = {
    "schedules": [
        {
            "id": 1,
            "cup_id": 1,
            "home_team": {
                "id": 1,
                "team_name": "巨人",
                "league_id": 1,
                "division_id": 1
            },
            "away_team": {
                "id": 1,
                "team_name": "巨人",
                "league_id": 1,
                "division_id": 1
            },
            "game_date": "2020/03/23",
            "scheduled_game_start_ymd": "20200425",
            "scheduled_game_start_hms": "180000",
            "stadium_name": "東京ドーム",
            "round": 1,
            "series": 1,
            "pitchers": {
                "home": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                },
                "away": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                }
            }
        }
    ],
    "graph": [
        {
            "title": "1試合平均得点",
            "data": [
                {
                    "month": 3,
                    "value": 0.11
                },
                {
                    "month": 4,
                    "value": 0.17
                },
                {
                    "month": 5,
                    "value": 0.12
                },
                {
                    "month": 6,
                    "value": 0.24
                }
            ]
        },
        {
            "title": "2試合平均得点",
            "data": [
                {
                    "month": 7,
                    "value": 0.24
                },
                {
                    "month": 8,
                    "value": 0.14
                },
                {
                    "month": 9,
                    "value": 0.64
                }
            ]
        }
    ],
    "top3_batters": [
        {
            "title": "打率",
            "value_label": "打率",
            "players": [
                {
                    "rank": 1,
                    "player_name": "選手名",
                    "value": ".222"
                }
            ]
        }
    ],
    "top3_pitchers": [
        {
            "title": "打率",
            "value_label": "打率",
            "players": [
                {
                    "rank": 1,
                    "player_name": "選手名",
                    "value": ".222"
                }
            ]
        }
    ],
    "top3_used": [
        {
            "title": "打率",
            "value_label": "打率",
            "players": [
                {
                    "rank": 1,
                    "player_name": "選手名",
                    "value": ".222"
                }
            ]
        }
    ]
}

export const playerBatter = {
    "common": {
        "deregistrations": [
            {
                "id": 1,
                "transfer_date": "2020/03/20",
                "transfer_id": 1,
                "transfer_reason": "xxx",
                "team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "player": {
                    "id": 1,
                    "team": {
                        "id": 1,
                        "team_name": "巨人",
                        "league_id": 1,
                        "division_id": 1
                    },
                    "uniform_number": "35",
                    "position_type": "セカンド",
                    "register_name": "菅野　智之",
                    "player_name": "菅野　智之"
                }
            }
        ],
        "record_to_be_lasts": [
            {
                "id": 1,
                "record_name": "2000安打",
                "remaining_achievement_cnt": 12
            }
        ]
    },
    "hotozone": {
        "left": [
            {
                "color": "#552200",
                "upper": "35 - 9",
                "middle": ".368",
                "lower": "HR 2 | K11"
            }
        ],
        "right": [
            {
                "color": "#552200",
                "upper": "35 - 9",
                "middle": ".368",
                "lower": "HR 2 | K11"
            }
        ]
    },
    "batted_ball_direction": {
        "5dive": [
            {
                "color": "#552200",
                "ratio": 10
            },
            {
                "color": "red",
                "ratio": 20
            }
        ],
        "3dive": [
            {
                "color": "#552200",
                "ratio": 10
            },
            {
                "color": "red",
                "ratio": 50
            },
            {
                "color": "#552200",
                "ratio": 10
            },
            {
                "color": "red",
                "ratio": 20
            },
            {
                "color": "red",
                "ratio": 20
            }
        ]
    }
}

export const playerGamelog = {
    "pitcher": [
        {
            "id": 1,
            "month": 10,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "gs": 1,
            "perfect_game": 1,
            "cg": 1,
            "gf": 1,
            "tosho": 1,
            "hokai": 1,
            "sho": 1,
            "mushikyu": 1,
            "qs": 1,
            "w": 1,
            "l": 1,
            "sv": 1,
            "sp": 1,
            "hld": 1,
            "hp": 1,
            "ip_out": 1,
            "ip": 1,
            "ip_frac": 1,
            "bf": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "sh": 1,
            "sf": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "so": 1,
            "wp": 1,
            "bk": 1,
            "r": 1,
            "er": 1,
            "np": 1,
            "era": 0.1,
            "avg": 0.1,
            "wpct": 0.1,
            "k9": 0.1,
            "qs_pct": 0.1,
            "whip": 0.1,
            "k_bb": 1
        },
        {
            "id": 1,
            "month": 10,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "gs": 1,
            "perfect_game": 1,
            "cg": 1,
            "gf": 1,
            "tosho": 1,
            "hokai": 1,
            "sho": 1,
            "mushikyu": 1,
            "qs": 1,
            "w": 1,
            "l": 1,
            "sv": 1,
            "sp": 1,
            "hld": 1,
            "hp": 1,
            "ip_out": 1,
            "ip": 1,
            "ip_frac": 1,
            "bf": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "sh": 1,
            "sf": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "so": 1,
            "wp": 1,
            "bk": 1,
            "r": 1,
            "er": 1,
            "np": 1,
            "era": 0.1,
            "avg": 0.1,
            "wpct": 0.1,
            "k9": 0.1,
            "qs_pct": 0.1,
            "whip": 0.1,
            "k_bb": 1
        }
    ],
    "batter": [
        {
            "id": 1,
            "month": 10,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "pa": 1,
            "ab": 1,
            "r": 1,
            "h": 1,
            "h2b": 1,
            "h3b": 1,
            "hr": 1,
            "tb": 1,
            "rbi": 1,
            "game_winning_rbi": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "sh": 1,
            "sf": 1,
            "sb": 1,
            "cs": 1,
            "defensive_interference": 1,
            "gidp": 1,
            "ab_risp": 1,
            "h_risp": 1,
            "avg": 1,
            "slg": 1,
            "obp": 1,
            "avg_risp": 1,
            "sb_pct": 1,
            "ops": 1
        }
    ]
}

export const playerGamelogPitcher = [
    {
        "id": 1,
        "game_id": 1,
        "game_date": "2020/04/05",
        "opponent_team_id": 1,
        "opponent_team_name": 1,
        "year_id": 1,
        "season_id": 1,
        "team_id": 1,
        "team_name": 1,
        "player_id": 1,
        "player_name": 1,
        "uniform_number": 1,
        "g": 1,
        "gs": 1,
        "perfect_game": 1,
        "cg": 1,
        "gf": 1,
        "tosho": 1,
        "hokai": 1,
        "sho": 1,
        "mushikyu": 1,
        "qs": 1,
        "w": 1,
        "l": 1,
        "sv": 1,
        "sp": 1,
        "hld": 1,
        "hp": 1,
        "ip_out": 1,
        "ip": 1,
        "ip_frac": 1,
        "bf": 1,
        "ab": 1,
        "h": 1,
        "hr": 1,
        "sh": 1,
        "sf": 1,
        "bb": 1,
        "hbp": 1,
        "ibb": 1,
        "so": 1,
        "wp": 1,
        "bk": 1,
        "r": 1,
        "er": 1,
        "np": 1,
        "era": 0.1,
        "avg": 0.1,
        "wpct": 0.1,
        "k9": 0.1,
        "qs_pct": 0.1,
        "whip": 0.1,
        "k_bb": 1
    }
]

export const playerGamelogBatter = [
    {
        "id": 1,
        "game_id": 1,
        "game_date": "2020/04/05",
        "opponent_team_id": 1,
        "opponent_team_name": 1,
        "year_id": 1,
        "season_id": 1,
        "team_id": 1,
        "team_name": 1,
        "player_id": 1,
        "player_name": 1,
        "uniform_number": 1,
        "g": 1,
        "pa": 1,
        "ab": 1,
        "r": 1,
        "h": 1,
        "h2b": 1,
        "h3b": 1,
        "hr": 1,
        "tb": 1,
        "rbi": 1,
        "game_winning_rbi": 1,
        "so": 1,
        "bb": 1,
        "hbp": 1,
        "ibb": 1,
        "sh": 1,
        "sf": 1,
        "sb": 1,
        "cs": 1,
        "defensive_interference": 1,
        "gidp": 1,
        "ab_risp": 1,
        "h_risp": 1,
        "avg": 1,
        "slg": 1,
        "obp": 1,
        "avg_risp": 1,
        "sb_pct": 1,
        "ops": 1
    }
];

export const playerConditionPitcher = {
    "central_league": [
        {
            "id": 1,
            "opponent_team_id": 1,
            "opponent_team_name": 1,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": "選手",
            "uniform_number": 1,
            "g": 1,
            "gs": 1,
            "perfect_game": 1,
            "cg": 1,
            "gf": 1,
            "tosho": 1,
            "hokai": 1,
            "sho": 1,
            "mushikyu": 1,
            "qs": 1,
            "w": 1,
            "l": 1,
            "sv": 1,
            "sp": 1,
            "hld": 1,
            "hp": 1,
            "ip_out": 1,
            "ip": 1,
            "ip_frac": 1,
            "bf": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "sh": 1,
            "sf": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "so": 1,
            "wp": 1,
            "bk": 1,
            "r": 1,
            "er": 1,
            "np": 1,
            "era": 0.1,
            "avg": 0.1,
            "wpct": 0.1,
            "k9": 0.1,
            "qs_pct": 0.1,
            "whip": 0.1,
            "k_bb": 1
        }
    ],
    "pacific_league": [
        {
            "opponent_team_id": 1,
            "opponent_team_name": 1,
            "id": 1,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "gs": 1,
            "perfect_game": 1,
            "cg": 1,
            "gf": 1,
            "tosho": 1,
            "hokai": 1,
            "sho": 1,
            "mushikyu": 1,
            "qs": 1,
            "w": 1,
            "l": 1,
            "sv": 1,
            "sp": 1,
            "hld": 1,
            "hp": 1,
            "ip_out": 1,
            "ip": 1,
            "ip_frac": 1,
            "bf": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "sh": 1,
            "sf": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "so": 1,
            "wp": 1,
            "bk": 1,
            "r": 1,
            "er": 1,
            "np": 1,
            "era": 0.1,
            "avg": 0.1,
            "wpct": 0.1,
            "k9": 0.1,
            "qs_pct": 0.1,
            "whip": 0.1,
            "k_bb": 1
        }
    ],
    "monthly": [
        {
            "id": 1,
            "month": 10,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "gs": 1,
            "perfect_game": 1,
            "cg": 1,
            "gf": 1,
            "tosho": 1,
            "hokai": 1,
            "sho": 1,
            "mushikyu": 1,
            "qs": 1,
            "w": 1,
            "l": 1,
            "sv": 1,
            "sp": 1,
            "hld": 1,
            "hp": 1,
            "ip_out": 1,
            "ip": 1,
            "ip_frac": 1,
            "bf": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "sh": 1,
            "sf": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "so": 1,
            "wp": 1,
            "bk": 1,
            "r": 1,
            "er": 1,
            "np": 1,
            "era": 0.1,
            "avg": 0.1,
            "wpct": 0.1,
            "k9": 0.1,
            "qs_pct": 0.1,
            "whip": 0.1,
            "k_bb": 1
        }
    ],
    "right.left": [
        {
            "opponent_neam": 10,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "avg": 0.1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1
        }
    ],
    "stadium": [
        {
            "id": 1,
            "stadium_neam": "東京ドーム",
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "gs": 1,
            "perfect_game": 1,
            "cg": 1,
            "gf": 1,
            "tosho": 1,
            "hokai": 1,
            "sho": 1,
            "mushikyu": 1,
            "qs": 1,
            "w": 1,
            "l": 1,
            "sv": 1,
            "sp": 1,
            "hld": 1,
            "hp": 1,
            "ip_out": 1,
            "ip": 1,
            "ip_frac": 1,
            "bf": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "sh": 1,
            "sf": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "so": 1,
            "wp": 1,
            "bk": 1,
            "r": 1,
            "er": 1,
            "np": 1,
            "era": 0.1,
            "avg": 0.1,
            "wpct": 0.1,
            "k9": 0.1,
            "qs_pct": 0.1,
            "whip": 0.1,
            "k_bb": 1
        }
    ]
}

export const playerConditionBatter = {
    "central_league": [
        {
            "id": 1,
            "opponent_team_id": 1,
            "opponent_team_name": 1,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "pa": 1,
            "ab": 1,
            "r": 1,
            "h": 1,
            "h2b": 1,
            "h3b": 1,
            "hr": 1,
            "tb": 1,
            "rbi": 1,
            "game_winning_rbi": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "sh": 1,
            "sf": 1,
            "sb": 1,
            "cs": 1,
            "defensive_interference": 1,
            "gidp": 1,
            "ab_risp": 1,
            "h_risp": 1,
            "avg": 1,
            "slg": 1,
            "obp": 1,
            "avg_risp": 1,
            "sb_pct": 1,
            "ops": 1
        }
    ],
    "pacific_league": [
        {
            "opponent_team_id": 1,
            "opponent_team_name": 1,
            "id": 1,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "pa": 1,
            "ab": 1,
            "r": 1,
            "h": 1,
            "h2b": 1,
            "h3b": 1,
            "hr": 1,
            "tb": 1,
            "rbi": 1,
            "game_winning_rbi": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "sh": 1,
            "sf": 1,
            "sb": 1,
            "cs": 1,
            "defensive_interference": 1,
            "gidp": 1,
            "ab_risp": 1,
            "h_risp": 1,
            "avg": 1,
            "slg": 1,
            "obp": 1,
            "avg_risp": 1,
            "sb_pct": 1,
            "ops": 1
        }
    ],
    "monthly": [
        {
            "id": 1,
            "month": 10,
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "pa": 1,
            "ab": 1,
            "r": 1,
            "h": 1,
            "h2b": 1,
            "h3b": 1,
            "hr": 1,
            "tb": 1,
            "rbi": 1,
            "game_winning_rbi": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "sh": 1,
            "sf": 1,
            "sb": 1,
            "cs": 1,
            "defensive_interference": 1,
            "gidp": 1,
            "ab_risp": 1,
            "h_risp": 1,
            "avg": 1,
            "slg": 1,
            "obp": 1,
            "avg_risp": 1,
            "sb_pct": 1,
            "ops": 1
        }
    ],
    "right.left": [
        {
            "id": 1,
            "opponent_neam": 10,
            "batter_bat": 10,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "pa": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "rbi": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1,
            "sh": 1,
            "sf": 1,
            "avg": 1
        }
    ],
    "count": [
        {
            "id": 1,
            "count_neam": "0-1",
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "pa": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "rbi": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1,
            "sh": 1,
            "sf": 1,
            "avg": 1
        }
    ],
    "runners_on": [
        {
            "id": 1,
            "runners_on_neme": "一二塁",
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "pa": 1,
            "ab": 1,
            "h": 1,
            "hr": 1,
            "rbi": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1,
            "sh": 1,
            "sf": 1,
            "avg": 1
        }
    ],
    "stadium": [
        {
            "id": 1,
            "stadium_neam": "東京ドーム",
            "year_id": 1,
            "season_id": 1,
            "team_id": 1,
            "team_name": 1,
            "player_id": 1,
            "player_name": 1,
            "uniform_number": 1,
            "g": 1,
            "pa": 1,
            "ab": 1,
            "r": 1,
            "h": 1,
            "h2b": 1,
            "h3b": 1,
            "hr": 1,
            "tb": 1,
            "rbi": 1,
            "game_winning_rbi": 1,
            "so": 1,
            "bb": 1,
            "hbp": 1,
            "ibb": 1,
            "sh": 1,
            "sf": 1,
            "sb": 1,
            "cs": 1,
            "defensive_interference": 1,
            "gidp": 1,
            "ab_risp": 1,
            "h_risp": 1,
            "avg": 1,
            "slg": 1,
            "obp": 1,
            "avg_risp": 1,
            "sb_pct": 1,
            "ops": 1
        }
    ]
}


export const leaderBoardCustom = [
    {
        "id": 1,
        "name": "打率分析",
        "report_id": 1,
        "year_id": 1,
        "team_ids": [
            1
        ],
        "player_ids": [
            1
        ],
        "columns": [
            "項目名"
        ],
        "sort": "avg",
        "order": "asc",
        "filters": [
            {
                "column": "項目",
                "value": "値"
            }
        ]
    },
    {
        "id": 1,
        "name": "打率分析",
        "report_id": 1,
        "year_id": 1,
        "team_ids": [
            1
        ],
        "player_ids": [
            1
        ],
        "columns": [
            "項目名"
        ],
        "sort": "avg",
        "order": "asc",
        "filters": [
            {
                "column": "項目",
                "value": "値"
            }
        ]
    },
    {
        "id": 1,
        "name": "打率分析",
        "report_id": 1,
        "year_id": 1,
        "team_ids": [
            1
        ],
        "player_ids": [
            1
        ],
        "columns": [
            "項目名"
        ],
        "sort": "avg",
        "order": "asc",
        "filters": [
            {
                "column": "項目",
                "value": "値"
            }
        ]
    }
]

export const myTopic = {
    "data": [
        {
            "id": 1,
            "workspace": {
                "id": 1,
                "title": "ワークスペースタイトル",
                "memo": "メモメモメモメモ",
                "topics_count": 1,
                "deliveried_at": "2019/05/18 06:00:00",
                "created_at": "2019/05/18 06:00:00",
                "updated_at": "2019/05/18 06:00:00",
                "is_unread": 0
            },
            "title": "Topicsタイトル",
            "category_name": "game",
            "game": {
                "id": 1,
                "cup_id": 1,
                "home_team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "away_team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "game_date": "2020/03/23",
                "scheduled_game_start_ymd": "20200425",
                "scheduled_game_start_hms": "180000",
                "stadium_name": "東京ドーム",
                "round": 1,
                "series": 1,
                "pitchers": {
                    "home": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    },
                    "away": {
                        "id": 1,
                        "team": {
                            "id": 1,
                            "team_name": "巨人",
                            "league_id": 1,
                            "division_id": 1
                        },
                        "uniform_number": "35",
                        "position_type": "セカンド",
                        "register_name": "菅野　智之",
                        "player_name": "菅野　智之"
                    }
                }
            },
            "team": {
                "id": 1,
                "team_name": "巨人",
                "league_id": 1,
                "division_id": 1
            },
            "player": {
                "id": 1,
                "team": {
                    "id": 1,
                    "team_name": "巨人",
                    "league_id": 1,
                    "division_id": 1
                },
                "uniform_number": "35",
                "position_type": "セカンド",
                "register_name": "菅野　智之",
                "player_name": "菅野　智之"
            },
            "created_at": "2019/05/18 06:00:00",
            "updated_at": "2019/05/18 06:00:00"
        }
    ]
}

function mapData(data) {
    for (let index = 0; index < 13; index++) {
        data.push(data[0]);
    }
    return data;
}

mapData(dataDummy.adminDelivery.data);
mapData(dataDummy.delivery.data);
mapData(dataDummy.deliveryWorkspace.data);
mapData(dataDummy.playlogSearch.data);
mapData(dataDummy.teamPitchers.data);
mapData(dataDummy.teamBatters.data);
mapData(dataDummy.teamSchedule.data);
mapData(dataDummy.playerReportPitcher.common.record_to_be_lasts);
mapData(dataDummy.playerReportPitcher.ball_type_performances);
mapData(dataDummy.playerReportPitcher.ordinary_hits_summuries);
mapData(dataDummy.playerPerformance.pitcher);
mapData(dataDummy.playerPerformance.batter);
mapData(dataDummy.teamPublic.data);
mapData(dataDummy.news.data);
